
<div class="row">
    <div class="col-md-12">
        <div class="row"  style="background-color: grey;">

            <div class="col-md-6">
                <label style="color:black;display: inline-block;">Access online training</label>
            </div>
            <div class="col--md-6">
                <button id="btnOnlineTraining" style="background-color: red; float: right;" >Online Training</button>
            </div>

        </div>
        
        <div class="row">
            <div class="col-md-10">
                <label style="color:black">Current Training Status</label>
            </div>
            <div class="col-md-2">
                <button id="btnOnlineTraining" style="background-color: grey;float: right; width:20px;" class="" (click)='toggleDetails()'>{{showDetails?'-':'+'}}</button>
            </div>

        </div>

        <div class="row">
            <div *ngIf='showDetails'>
                <br>

                <table style="background-color: white;color: black;font-size:small;border-style:solid;border-width: 0px;">
                    <tr style="background-color:dimgray;color:white">
                        <th>Course ID</th>
                        <th>Course Name</th>
                        <th>Last Access</th>
                        <th>Completed date</th>
                        <th> Status</th>
                    </tr>


                    <tr *ngFor="let x of userCoursesViewModel">
                        <td>{{x.CourseID}}</td>
                        <td>{{x.CourseName}}</td>
                        <td>{{x.LastAccess}}</td>
                        <td>{{x.CompletionDate}}</td>
                        <td>{{x.Status}}</td>
                    </tr>

                </table>
            </div>
            <br />
            <div *ngIf='showDetails'>
                <span>
                    <b style="color:black;">The table above shows your current Training and Certification status. If you belive any of information is incorrect, please email <a href="mailto:ProducerSalesResource@Caremark.com">ProducerSalesResource&#64;Caremark.com</a> with the correct information</b>
                </span>
            </div>
            </div>

        <div class="row">
            <div class="col-md-10">
                <label style="color:black"> Upload AHIP / Gorman Certificate </label>
            </div>
            <div class="col-md-2">
                <button id="btnOnlineTraining" style="background-color: grey;float: right; width:20px;" class="" (click)='toggleDetails5()'>{{showDetails5?'-':'+'}}</button>
            </div>
        </div>
        <div class="row">
            <div *ngIf='showDetails5'>
                <br/>
                <div><label style="color:red;display: inline-block;"> No special characters in the file name please </label></div>      
                <br/>        
                <div class="col-md-6">
                    <input type="text" id="upload" style="width: 62%;height: 32px;" />
                    <button id="btnOnlineTraining" style="background-color: red; float: right;"> Upload Certificate </button>
                </div>
            </div>
            <br />
            <div *ngIf='showDetails5'>
                <span>
                   
                </span>
            </div>
        </div>

        <div class="row">
            <div class="col-md-10">
                <label style="color:black">Verify Enrolment Kit shipping Address</label>
            </div>
            <div class="col-md-2">
                <button id="btnOnlineTraining" style="background-color: grey;float: right; width:20px;" class="" (click)='toggleDetails2()'>{{showDetails2?'-':'+'}}</button>
            </div>

        </div>
        <div class="row">
            <div *ngIf='showDetails2'>
                <br>
                <div>
                    We automatically place an <b style="color:black;"> initial order of 20 enrollment kits </b> for agents upon completion of the annual certification curriculum. You do not have to request anything for your first order.
                    Please scroll down to the bottom of this page to confirm your shipping address (keep in mind that we are unable to deliver to PO Boxes). You can order additional quantities after you complete your certification. Just click the <a href="https://www.silverscriptagentportal.com/agentportal/login.aspx?redirect=/agentportal/agent/Marketing.aspx">Supply Room </a>link and follow the instructions.
                    You may order additional enrollment kits (in multiples of 10) by sending a message to us via the SilverScript Portal's Silver Mail system (located in the top left corner of this page). Be certain to provide us with your name, shipping address, phone number, and the quantity you need. We will ship the kits via UPS ground service.
                    Please note that the “Initial Supply” functionality is only displayed to agents associated with organizations that distribute SilverScript PDP enrollment kits.
               </div>             
            </div>
            <br />
            <div *ngIf='showDetails2'>
                <span>
                   
                </span>
            </div>
        </div>

        <div class="row">
            <div class="col-md-10">
                <label style="color:black">2016 Training and Certification is now Online</label>
            </div>
            <div class="col-md-2">
                <button id="btnOnlineTraining" style="background-color: grey;float: right; width:20px;" class="" (click)='toggleDetails3()'>{{showDetails3?'-':'+'}}</button>
            </div>

        </div>
        <div class="row">
            <div *ngIf='showDetails3'>
                <br>
                <div>
                    <b style="color:black;">
                        Just four easy steps to find your 2016 courses:
                    </b>
                    <ul>
                        <li>
                            1. At the top of the left column, click the button that reads “Change Plan Year” and select 2016.
                        </li>
                        <li>
                            2. At the bottom of this screen, you’ll see a table with your 2016 courses listed. Click the button that reads “Click Here to Access Online Training.”
                        </li>
                        <li>
                            3. Our training site will load (it may take a few seconds) and you’ll see a green icon next to the name of your curriculum.Click the icon with the arrow pointing to the right to get started with your training.
                        </li>
                        <li>
                            4. Click the green icon and your courses will appear.
                        </li>
                    </ul>
                    <span>
                        We suggest that you visit the Enrollment Portal's Reference Materials page and review or download the PDF course workbooks listed under 2016 CERTIFICATION TRAINING MODULE. They’re an excellent resource for you.

                        If you’ve already passed your AHIP or Gorman training, you will not have to take our Medicare Overview or Compliance course. Please read below on how you can get credit for that training.
                    </span>
                </div>
            </div>
            <br />
            <div *ngIf='showDetails3'>
                <span>
                   
                </span>
            </div>
        </div>

        <div class="row">
            <div class="col-md-10">
                <label style="color:black">Important Time Saving information if you've completed AHIP
                 <br /> or Gorman 2015 or 2016 Medicare Part D annual certification </label>
            </div>
            <div class="col-md-2">
                <button id="btnOnlineTraining" style="background-color: grey;float: right; width:20px;" class="" (click)='toggleDetails4()'>{{showDetails4?'-':'+'}}</button>
            </div>

        </div>
        <div class="row">
            <div *ngIf='showDetails4'>
                <br>
                <div>
                    There are four courses you need to pass in order to sell SilverScript Part D plans to your clients. You’ll earn credit for two of them -- <b style="color:black;">the SilverScript Insurance Company Medicare Overview </b> course and the <b style="color:black;">Compliance</b> course -- as soon as we receive your <b style="color:black;">AHIP or Gorman 2015 or 2016 Medicare Part D completion certificate</b>.

                    Please note that you are <b style="color:black;">still required to complete</b> the SilverScript Product & Process course and the SilverScript Attestation course.
                </div>
            </div>
            <br />
            <div *ngIf='showDetails4'>
                <span>
                    
                </span>
            </div>
        </div>
    </div>
</div>
